import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "privacy-policy",
  class: "relative py-32"
}
const _hoisted_2 = { class: "container relative" }
const _hoisted_3 = { class: "grid grid-cols-1" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = { class: "pb-6" }
const _hoisted_6 = { class: "pt-6 bg-dark text-white" }

import {openMail} from "@/utils/mail";
import {onMounted} from "vue";

import {useLoaderState} from "@/store/isloading";

import Navbar from "@/components/layout/navbar.vue";
import Info from "@/components/layout/info.vue";
import Footer from "@/components/layout/footer.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'impressum',
  setup(__props) {

const isLoading = useLoaderState();
const { changeStateTrue } = isLoading;

onMounted(() => {
	changeStateTrue();

	setTimeout(() => {
		const { changeStateFalse } = isLoading;
		changeStateFalse();
	}, 1000);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title grid grid-cols-1 mb-8 text-center" }, [
          _createElementVNode("h4", { class: "text-4xl font-bold mb-3" }, "Impressum"),
          _createElementVNode("div", { class: "border" })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createStaticVNode("<h3 class=\"pb-8\">Angaben gemäß § 5 TMG:</h3><h5 class=\"font-semibold pb-2\">Bogenschützen Münster e.V. von 1979</h5><p class=\"pb-6\"> Werseesch<br> 48157 Münster </p><h4 class=\"font-semibold pb-2\">Vertreten durch:</h4><p class=\"pb-6\"> unbesetzt (1. Vorsitzender)<br> Andrea Seidel (2. Vorsitzende) </p><h5 class=\"font-semibold pb-2\">Kontakt:</h5>", 6)),
            _createElementVNode("p", _hoisted_5, [
              _cache[1] || (_cache[1] = _createTextVNode(" Telefon: 0160 928 464 12")),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _cache[3] || (_cache[3] = _createTextVNode(" E-Mail: ")),
              _createElementVNode("span", {
                class: "cryptedmail",
                "data-name": "info",
                "data-domain": "bogenschuetzen-muenster",
                "data-tld": "de",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openMail) && _unref(openMail)(...args)), ["prevent"]))
              }),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _cache[5] || (_cache[5] = _createTextVNode(" Internet: ")),
              _cache[6] || (_cache[6] = _createElementVNode("a", {
                title: "Bogenschützen Münster e.V. von 1979",
                href: "https://www.bogenschuetzen-muenster.de"
              }, "https://www.bogenschuetzen-muenster.de", -1))
            ]),
            _cache[8] || (_cache[8] = _createStaticVNode("<h5 class=\"font-semibold pb-2\">Postanschrift:</h5><p class=\"pb-6\"> Bogenschützen Münster e.V. von 1979<br> Postfach 1524<br> 48004 Münster </p><h5 class=\"font-semibold pb-2\">Registereintrag:</h5><p class=\"pb-6\"> Eintragung im Vereinsregister.<br> Registergericht: Amtsgericht Münster<br> Registernummer: VR 2342 </p><h5 class=\"font-semibold pb-2\">Inhaltlicher Verantwortlicher im Sinne des § 18 Abs. 2 MStV:</h5><p class=\"pb-6\"> Marco Köhler<br> Legdenweg 78<br> 48161 Münster </p><h5 class=\"font-semibold pb-2\">Bankverbindung</h5><p class=\"pb-6\"> Sparkasse Münsterland Ost<br> IBAN: DE98400501500003001997<br> BIC: WELADED1MST </p><h4 class=\"font-semibold pb-2\">Haftungsausschluss:</h4><b class=\"pb-2\">Haftung für Inhalte</b><p class=\"pb-4\">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p><p class=\"pb-4\">Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p><b class=\"pb-2\">Haftung für Links</b><p class=\"pb-4\">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p><p class=\"pb-4\">Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p><b class=\"pb-2\">Urheberrecht</b><p class=\"pb-4\">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p><p class=\"pb-4\">Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>", 18))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(Info)
    ]),
    _createVNode(Footer),
    _createVNode(ScrollToTop)
  ], 64))
}
}

})